/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ArrowSmallUpIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAsElEQVR4nO2QTQrCMBBGcwgLeqMinZ8uhhnxRJ7Bk+hCQTe6VAs9jhIxtgUhVOMuD0IWCd+b+ZzLpKKqFhNgPQHpuRQpXEpKkQJZL8h2fx7Sdi4y/U84J5T4Wrpwbbpwu4X767oGk5O2db2cBYF/A9brT5sg6dYH+KAwZRC8B3htAmy78QLWFZJt+hX0BUECbHtgXY8WfJbaQJAczIIYmCuKgbmiGEh6BLZD9GPGjeABK86IepNElAEAAAAASUVORK5CYII=)
 */
export const ArrowSmallUpIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.7 3.3a1 1 0 0 0-1.4 0l-5 5a1 1 0 0 0 1.4 1.4L11 6.42V20a1 1 0 1 0 2 0V6.41l3.3 3.3a1 1 0 0 0 1.4-1.42l-5-5Z"
        className={colorClass}
      />
    </svg>
  );
};
